import FormProps from "data/forms"
import ClientEngagementFields from "./types"
import SearchSelect from "Components/molecule/inputs/search-select"
import { SelectOption } from "Components/molecule/inputs/select-input";
import DateInput from "Components/molecule/inputs/date-input";
import PrimaryButton from "Components/atoms/buttons/primary-button";
import SecondaryButton from "Components/atoms/buttons/secondary-button";
import TextAreaInput from "Components/molecule/inputs/textarea-inpuit";
import FormContainer from "Components/atoms/containers/form-container";

interface ClientEngagementFormProps extends FormProps<ClientEngagementFields> {
    clients: SelectOption[]
    opportunities: SelectOption[],
}

const CLIENT_KEY = "clientId";
const OPPORTUNITY_KEY = 'opportunityId';
const FEEDBACK_KEY = 'notes'
const DATE_OF_NEXT_CHECKIN_KEY = 'dateOfNextCheckin'


const ClientEngagementForm = ({
    handleChange,
    handleBlur,
    handleSubmit,
    handleCancel,
    clients,
    opportunities,
    touched,
    values,
    errors,
    isSubmitting,
    isValid,
}: ClientEngagementFormProps) => {


    return <FormContainer
        buttonsClassName="d-flex flex-column flex-md-row gap-2"
        inputs={<>
            <SearchSelect
                name={CLIENT_KEY}
                key={CLIENT_KEY}
                label={"Client*"}
                placeholder={"Client"}
                value={values.clientId}
                error={!!touched.clientId && !!errors.clientId}
                message={touched.clientId ? errors.clientId : undefined}
                options={clients}
                onChange={(option: SelectOption | null) => handleChange(CLIENT_KEY)(option ? option.value : '')}
                onBlur={handleBlur(CLIENT_KEY)}
                clearable={true}
                className="col-12 col-md-4"
            />

            <SearchSelect
                name={OPPORTUNITY_KEY}
                key={OPPORTUNITY_KEY}
                label={"Opportunity"}
                placeholder={"Opportunity"}
                value={values.opportunityId}
                error={!!touched.opportunityId && !!errors.opportunityId}
                message={touched.opportunityId ? errors.opportunityId : undefined}
                options={opportunities}
                onChange={(option: SelectOption | null) => handleChange(OPPORTUNITY_KEY)(option ? option.value : '')}
                onBlur={handleBlur(OPPORTUNITY_KEY)}
                clearable={true}
                className="col-12 col-md-4"
            />

            <DateInput
                name={DATE_OF_NEXT_CHECKIN_KEY}
                key={DATE_OF_NEXT_CHECKIN_KEY}
                label={"Date of next checkin"}
                placeholder={"Next Checkin?"}
                value={values.dateOfNextCheckin || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.dateOfNextCheckin && !!errors.dateOfNextCheckin}
                message={touched.dateOfNextCheckin ? errors.dateOfNextCheckin : undefined}
                className="col-12 col-md-4"
            />

            <TextAreaInput
                name={FEEDBACK_KEY}
                key={FEEDBACK_KEY}
                label={"Feedback"}
                placeholder={"Feedback"}
                value={values.notes}
                onBlur={handleBlur}
                onChange={handleChange}
                className="col-12 text-area-input"
                error={!!touched.notes && !!errors.notes}
                message={touched.notes ? errors.notes : undefined}
                max={2000}
            />
        </>}
        buttons={<>
            <PrimaryButton
                className="col-12 col-md-6 col-lg-2"
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Saving...." : "Save"}
            </PrimaryButton>
            {handleCancel &&
                <SecondaryButton
                    className="col-12 col-md-6 col-lg-2"
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Back
                </SecondaryButton>
            }
        </>}
    />
}


export default ClientEngagementForm